// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__1IhgD","secondary":"Button_secondary__1joyV"};